const steps = [
  {
    num: "01",
    title: "Start with the walls",
    desc: "Paint in warm white or soft cream. Avoid cool whites — they read grey in low light. This is the single most impactful change you can make to a small space.",
  },
  {
    num: "02",
    title: "Choose a compact sofa with legs",
    desc: "A two-seater or slim three-seater in oat or warm ivory linen. Visible legs are non-negotiable — they keep the floor feeling open and the room feeling larger.",
  },
  {
    num: "03",
    title: "Add a large, light-toned rug",
    desc: "Go bigger than feels comfortable. A large ivory or oat rug that extends under all your furniture unifies the space and makes the floor feel expansive.",
  },
  {
    num: "04",
    title: "Layer texture, not colour",
    desc: "Add depth through material variation — linen cushions, a boucle throw, a ceramic vase, a natural wood tray. Keep all tones within the warm neutral family.",
  },
  {
    num: "05",
    title: "Edit and leave space to breathe",
    desc: "Remove anything that doesn't earn its place. A small room with five considered pieces feels more spacious than one with ten average ones. Negative space is part of the design.",
  },
];

export default function SANFormula() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-screen-xl mx-auto px-8 md:px-16">
        <div className="max-w-3xl mx-auto">
          <p
            className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-4"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            The Method
          </p>
          <h2
            className="text-[#2C2825] text-3xl md:text-4xl mb-4"
            style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
          >
            The 5-Step Formula for a Calm Small Apartment
          </h2>
          <p
            className="text-[#8B8378] text-sm leading-relaxed mb-14"
            style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
          >
            Follow these steps in order and you'll have a small apartment that feels genuinely calm, open, and considered.
          </p>

          <div className="space-y-10">
            {steps.map((step, i) => (
              <div key={step.num} className="flex gap-8 items-start">
                <div className="flex-shrink-0 w-14 h-14 rounded-full bg-[#FAF7F0] flex items-center justify-center">
                  <span
                    className="text-[#C8BAA8] text-lg"
                    style={{ fontFamily: "'Playfair Display', serif" }}
                  >
                    {step.num}
                  </span>
                </div>
                <div className="flex-1 pt-3">
                  <h3
                    className="text-[#2C2825] text-base mb-2"
                    style={{ fontFamily: "'Inter', sans-serif", fontWeight: 500 }}
                  >
                    {step.title}
                  </h3>
                  <p
                    className="text-[#6B5E53] text-sm leading-[1.85]"
                    style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
                  >
                    {step.desc}
                  </p>
                </div>
                {i < steps.length - 1 && (
                  <div className="absolute" />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
